function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import colors from "../../foundations/colors.module.scss";
import shadows from "../../foundations/shadows.module.scss";
import typography from "../../foundations/typography.module.scss";
export * from "./MenuScrollbar.module.scss";
/**
 * Base menu paper styles used across TextField, InlineSelect, and other components.
 */
export const baseMenuPaperStyles = {
  backgroundColor: colors.white,
  borderRadius: 8,
  margin: '8px 0',
  boxShadow: shadows.sh60,
  border: "1px solid ".concat(colors.dark200)
};

/**
 * Base menu item styles used across TextField, InlineSelect, and other components.
 */
export const baseMenuItemStyles = {
  borderRadius: 4,
  margin: '2px 8px',
  transition: 'background-color 0.2s ease, color 0.2s ease',
  fontFamily: typography.fontFamilyLight,
  fontSize: typography.fontSizeP1,
  color: colors.dark700,
  padding: '8px 12px',
  minHeight: 'auto',
  opacity: 1,
  '&.Mui-selected': {
    backgroundColor: colors.dark100,
    color: "".concat(colors.dark900, " !important")
  },
  '&.Mui-disabled': {
    color: "".concat(colors.dark500, " !important"),
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: 'transparent !important'
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent !important'
    }
  },
  '&.Mui-focusVisible:not(.Mui-selected)': {
    backgroundColor: colors.dark70
  },
  '& .MuiTouchRipple-root': {
    display: 'none'
  },
  '&:hover:not(.Mui-selected):not(.Mui-disabled)': {
    backgroundColor: colors.dark70
  },
  '&:active:not(.Mui-selected):not(.Mui-disabled)': {
    backgroundColor: colors.dark100
  },
  '&:first-child': {
    marginTop: 0
  },
  '&:last-child': {
    marginBottom: 0
  }
};
export const menuStyles = {
  '&.MuiPaper-root': baseMenuPaperStyles,
  '& .MuiMenuItem-root': baseMenuItemStyles
};

/**
 * Base menu styles hook for use in components.
 * Returns styles that include both menu paper and menu item styles.
 */
export const useBaseMenuStyles = function useBaseMenuStyles() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    menu: _objectSpread({
      maxHeight: props.menuMaxHeight
    }, menuStyles),
    menuPaper: baseMenuPaperStyles,
    menuItem: baseMenuItemStyles
  };
};